import { render, staticRenderFns } from "./VeterinaryPatientList.vue?vue&type=template&id=47b4a522&scoped=true"
import script from "./VeterinaryPatientList.vue?vue&type=script&lang=js"
export * from "./VeterinaryPatientList.vue?vue&type=script&lang=js"
import style0 from "./VeterinaryPatientList.vue?vue&type=style&index=0&id=47b4a522&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b4a522",
  null
  
)

export default component.exports